import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./olo_handoff_mode.js";
//#region src/olo_handoff_mode_helper.ts
var olo_handoff_mode_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(handoffMode) {
	switch (handoffMode) {
		case "pickup": return "Pickup";
		case "curbside": return "Curbside";
		case "drivethru": return "Drive-Thru";
		case "delivery": return "Delivery";
		case "dispatch": return "Dispatch (3rd Party Delivery)";
		case "dinein": return "Dine In";
	}
}
//#endregion
export { name, olo_handoff_mode_helper_exports };

//# sourceMappingURL=olo_handoff_mode_helper.js.map